import React from 'react'

import clsx from 'clsx'

import * as styles from './RoomIndexFrame.module.scss'

import {
  BannerHurusatoNouzeiSmall,
  FacilitySearchPanel,
  LoginModal,
  MainColumn,
  MultiColumn,
  RoomIndex,
  SearchLayout,
  SearchMainContent,
  SearchPanel,
  SideColumn,
} from '../../components'
import { usePropertyProvider, useStorageEnabled } from '../../hooks'

export const RoomIndexFrame = () => {
  const { isHotel, isActivity } = usePropertyProvider()
  const storageEnabled = useStorageEnabled()
  return (
    <SearchLayout>
      {!storageEnabled && <LoginModal isOpen onClose={() => {}} nextPath="#" />}
      <SearchMainContent>
        <MultiColumn>
          <SideColumn>
            {isHotel ? (
              <SearchPanel />
            ) : (
              <FacilitySearchPanel isActivity={isActivity} />
            )}
            <div className={clsx(styles.bannerArea, 'pc')}>
              {isActivity ? null : <BannerHurusatoNouzeiSmall />}
            </div>
          </SideColumn>
          <MainColumn>
            <RoomIndex />
            <div className={clsx(styles.bannerArea, 'sp')}>
              {isActivity ? null : <BannerHurusatoNouzeiSmall />}
            </div>
          </MainColumn>
        </MultiColumn>
      </SearchMainContent>
    </SearchLayout>
  )
}
